import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./cart.css";
import { addToCart, removeCart } from "./../../action/cart_action";
import CartItem from "../../commons/cartItem/cartitem";
import { badgeDec, badgeInc } from "../../action/badge_adction";
import Button from "../../commons/button/button";
import { Link } from "react-router-dom";

const Cart = ({ match }) => {
  const dispatch = useDispatch();
  const id = match.params.id;
  const cartItems = useSelector((state) => state.cart);
  useEffect(() => {
    if (id) {
      dispatch(addToCart(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    let badgeNumber = localStorage.getItem("cartItems")
      ? JSON.parse(localStorage.getItem("cartItems"))
      : 0;
    console.log(badgeNumber, "bdg length");
    dispatch(badgeInc(badgeNumber.length));
  });
  const removeCartHandler = (product) => {
    dispatch(removeCart(product));
    const badgeNumber = JSON.parse(localStorage.getItem("cartItems"));
    console.log(badgeNumber.length);
    dispatch(badgeDec(badgeNumber.length));
  };

  const generatePricec = () => {
    let price = cartItems.cartItems.reduce((acc, item) => acc + item.price, 0);
    let str_price = String(price);
    let count_char_price = str_price.length;

    switch (count_char_price) {
      case 5:
        let first_sec = str_price.substring(0, 2);
        let secound_sec = str_price.substring(2);
        price = first_sec + "," + secound_sec;
        return price;
      case 4:
        first_sec = str_price.substring(0, 1);
        secound_sec = str_price.substring(1);
        price = first_sec + "," + secound_sec;
        return price;
      case 6:
        first_sec = str_price.substring(0, 3);
        secound_sec = str_price.substring(3);
        price = first_sec + "," + secound_sec;
        return price;
      case 7:
        first_sec = str_price.substring(0, 4);
        secound_sec = str_price.substring(4);
        price = first_sec + "," + secound_sec;
        return price;
      case 8:
        first_sec = str_price.substring(0, 8);
        secound_sec = str_price.substring(8);
        price = first_sec + "," + secound_sec;
        return price;
      default:
        break;
    }

    return price;
  };

  return (
    <Fragment>
      <div className="container cart_page_body">
        {cartItems.cartItems.map((item) => (
          <CartItem
            product={item.product}
            remove={(product) => removeCartHandler(product)}
            img={item.image}
            name={item.title}
            price={item.price}
          />
        ))}
        <div className="row basket_price ">
          {cartItems.cartItems.length == 0 ? (
            <p>سبد خالیه</p>
          ) : (
            <h6 className="price_body_row">
              {` ${generatePricec()}`}
              <span> تومان </span>
            </h6>
          )}
        </div>
        {cartItems.cartItems.length !== 0 ? (
          <div className="row sell_sec_body ">
            <Link to="/invoice">
              <Button
                boxShadow="0px 0px 13px -3px #636e72"
                background="#a5c926"
                color="white"
                heigh="35px"
                width="140px"
                radius="23px"
                padding="0 5px"
              >
                تکمیل خرید
              </Button>
            </Link>
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

export default Cart;
